(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ggs-ring-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ggmReady) return;
    root.dataset.ggmReady = 'true';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    const rail = root.querySelector('.ggm__tabs');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    const show = (index, focus = false) => {
      current = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === current));
        tab.tabIndex = i === current ? 0 : -1;
        panels[i].hidden = i !== current;
        panels[i].classList.toggle('is-active', i === current);
      });
      const tab = tabs[current];
      rail.scrollTo({left: tab.offsetLeft - rail.offsetLeft - (rail.clientWidth - tab.offsetWidth) / 2, behavior: reduced.matches ? 'instant' : 'smooth'});
      if (focus) tab.focus({preventScroll:true});
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => show(i));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = current + 1;
        if (event.key === 'ArrowLeft') next = current - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); show(next, true);
      });
    });
    root.querySelectorAll('[data-ggm-prev],[data-ggm-next]').forEach(button => {
      button.addEventListener('click', () => {
        const direction = button.hasAttribute('data-ggm-next') ? 1 : -1;
        show(current + direction);
        panels[current].querySelector(direction === 1 ? '[data-ggm-next]' : '[data-ggm-prev]').focus({preventScroll:true});
      });
    });
    root.querySelectorAll('.ggm__visual').forEach(visual => {
      let start;
      visual.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') start = [event.clientX,event.clientY]; });
      visual.addEventListener('pointerup', event => {
        if (!start) return;
        const dx = event.clientX-start[0], dy = event.clientY-start[1];
        if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.5) show(current+(dx<0?1:-1));
        start = null;
      });
      visual.addEventListener('pointercancel', () => { start = null; });
    });
  };
  document.querySelectorAll('.ggm').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ggm').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-ring-field-og-backup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ggfReady) return;
    root.dataset.ggfReady = 'true';
    const canvas = root.querySelector('.ggf__canvas');
    const ctx = canvas.getContext('2d', { alpha: true });
    const intro = root.querySelector('.ggf__intro');
    const chapters = [...root.querySelectorAll('[data-ggf-chapter]')];
    const tabs = [...root.querySelectorAll('[data-ggf-go]')];
    const currentLabel = root.querySelector('[data-ggf-current]');
    const closing = root.querySelector('.ggf__closing');
    const spectrum = root.querySelector('.ggf__spectrum');
    const curveGroup = root.querySelector('.ggf__curve-lines');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    root.querySelectorAll('.ggf__curve-link').forEach(line => {
      line.addEventListener('pointerenter', () => { curveGroup?.classList.add('is-hovering'); line.classList.add('is-hover'); }, options);
      line.addEventListener('pointerleave', () => { curveGroup?.classList.remove('is-hovering'); line.classList.remove('is-hover'); }, options);
      line.addEventListener('focus', () => { curveGroup?.classList.add('is-hovering'); line.classList.add('is-hover'); }, options);
      line.addEventListener('blur', () => { curveGroup?.classList.remove('is-hovering'); line.classList.remove('is-hover'); }, options);
      line.addEventListener('dblclick', event => { if (line.dataset.report) { event.preventDefault(); window.open(line.dataset.report, '_blank', 'noopener'); } }, options);
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let width = 0, height = 0, dpr = 1, count = 0, active = -2, raf = 0, time = 0, pointerX = 0, pointerY = 0, down = null;

    const fract = n => n - Math.floor(n);
    const rand = (i, seed) => fract(Math.sin(i * 12.9898 + seed * 78.233) * 43758.5453);
    const mix = (a, b, t) => a + (b - a) * t;
    const ease = t => t * t * (3 - 2 * t);

    function target(phase, i) {
      const r1 = rand(i, phase + 1), r2 = rand(i, phase + 7), r3 = rand(i, phase + 13);
      const cx = width * .72, cy = height * .52, span = Math.min(width, height);
      let x = cx, y = cy, color = 0, size = .7 + r3 * 1.4;
      if (phase === 0) {
        const jar = i < count * .78;
        if (jar) {
          const t = r1 * 4;
          const rw = Math.min(width * .22, 300), rh = Math.min(height * .3, 300);
          if (t < 1) { x = cx - rw + t * rw * 2; y = cy - rh; }
          else if (t < 2) { x = cx + rw; y = cy - rh + (t - 1) * rh * 2; }
          else if (t < 3) { x = cx + rw - (t - 2) * rw * 2; y = cy + rh; }
          else { x = cx - rw; y = cy + rh - (t - 3) * rh * 2; }
          x += (r2 - .5) * 7; y += (r3 - .5) * 7;
        } else {
          const wick = i % 3 - 1, t = r1;
          x = cx + wick * 52 + Math.sin(t * 8) * 5;
          y = cy - Math.min(height * .3, 300) - t * 95;
          color = 1;
        }
      } else if (phase === 1) {
        const t = i / count, lane = i % 5;
        const rise = fract(t * 5);
        const radius = 35 + lane * 32 + rise * 75;
        x = cx + Math.cos(rise * 8 + lane) * radius;
        y = height * .82 - rise * height * .67;
        color = lane % 2;
      } else if (phase === 2) {
        const lane = i % 9, t = Math.floor(i / 9) / Math.ceil(count / 9);
        x = cx - 150 + lane * 38 + Math.sin(t * 16 + lane) * 22;
        y = height * .84 - t * height * .7;
        color = lane % 3 === 0 ? 1 : 0;
      } else if (phase === 3) {
        const band = i % 3, t = Math.floor(i / 3) / Math.ceil(count / 3);
        x = width * .45 + t * width * .5;
        y = height * (.39 + band * .15) + Math.sin(t * 15 + band * 2) * 24 + (r2 - .5) * 15;
        color = band === 1 ? 1 : band === 2 ? 2 : 0;
        size += 1;
      } else if (phase === 4) {
        const angle = r1 * Math.PI * 2, radius = Math.sqrt(r2) * span * .31;
        x = cx + Math.cos(angle) * radius;
        y = cy + Math.sin(angle) * radius * .82;
        color = r3 > .72 ? 2 : 0;
        size = r3 > .92 ? 3.4 : .8 + r2 * 1.5;
      } else {
        const perimeter = i < count * .44;
        const rw = Math.min(width * .28, 390), rh = Math.min(height * .35, 340);
        if (perimeter) {
          const t = r1 * 4;
          if (t < 1) { x = cx - rw + t * rw * 2; y = cy - rh; }
          else if (t < 2) { x = cx + rw; y = cy - rh + (t - 1) * rh * 2; }
          else if (t < 3) { x = cx + rw - (t - 2) * rw * 2; y = cy + rh; }
          else { x = cx - rw; y = cy + rh - (t - 3) * rh * 2; }
        } else if (i < count * .70) {
          const angle = r1 * Math.PI * 2, radius = 22 + r2 * 58;
          x = cx - 205 + Math.cos(angle) * radius; y = cy - 125 + Math.sin(angle) * radius;
          color = 2; size = 1 + r3 * 1.5;
        } else {
          const t = r1 * Math.PI * 2, radius = 22 + r2 * 45;
          x = cx + 185 + Math.cos(t) * radius; y = cy - 120 + Math.sin(t) * radius * .55;
          color = 1; size = 1 + r3 * 1.8;
        }
        if (perimeter) {
          x += (r2 - .5) * 5; y += (r3 - .5) * 5; color = i % 8 === 0 ? 1 : 0;
        } else if (i < count * .70) {
          x += Math.cos(r3 * 12) * 5; y += Math.sin(r2 * 12) * 5;
        } else {
          x += (r2 - .5) * 5; y += (r3 - .5) * 5;
        }
      }
      return { x, y, color, size };
    }

    function measure() {
      dpr = Math.min(devicePixelRatio || 1, 2);
      width = canvas.clientWidth; height = canvas.clientHeight;
      canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      count = innerWidth < 640 ? 480 : 1180;
      draw();
    }

    function progress() {
      const rect = root.getBoundingClientRect();
      const travel = Math.max(1, root.offsetHeight - innerHeight);
      return Math.max(0, Math.min(1, -rect.top / travel));
    }

    function setActive(index) {
      if (active === index) return;
      active = index;
      intro.classList.toggle('is-past', index >= 0);
      chapters.forEach((chapter, i) => chapter.classList.toggle('is-active', i === index));
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
      currentLabel.textContent = index < 0 ? '00' : String(index + 1).padStart(2, '0');
      closing.classList.toggle('is-active', index === 5);
      spectrum.classList.toggle('is-active', index === 5);
    }

    function draw() {
      raf = 0;
      const p = reduced.matches || innerWidth < 640 ? 0 : progress();
      const story = Math.max(0, (p - .1) / .9);
      const raw = Math.min(5.999, story * 6);
      const phase = Math.floor(raw), local = ease(raw - phase), next = Math.min(5, phase + 1);
      setActive(p < .12 ? -1 : Math.min(5, Math.floor(Math.max(0, (p - .12) / .88) * 6)));
      ctx.clearRect(0, 0, width, height);
      const driftX = pointerX * 18, driftY = pointerY * 12;
      for (let i = 0; i < count; i++) {
        const a = target(phase, i), b = target(next, i);
        const x = mix(a.x, b.x, local) + driftX * (rand(i, 31) - .5);
        const y = mix(a.y, b.y, local) + driftY * (rand(i, 47) - .5) + Math.sin(time * .00035 + i) * 1.2;
        const c = local < .5 ? a.color : b.color;
        ctx.fillStyle = c === 1 ? 'rgba(80,122,54,.78)' : c === 2 ? 'rgba(120,152,90,.78)' : c === 3 ? 'rgba(139,157,102,.78)' : c === 4 ? 'rgba(167,184,137,.82)' : 'rgba(23,51,29,.42)';
        ctx.beginPath(); ctx.arc(x, y, mix(a.size, b.size, local), 0, Math.PI * 2); ctx.fill();
      }
      time = performance.now();
    }

    function requestDraw() { if (!raf) raf = requestAnimationFrame(draw); }
    function go(index) {
      const clamped = Math.max(0, Math.min(5, index));
      const sectionTop = root.getBoundingClientRect().top + scrollY;
      const travel = root.offsetHeight - innerHeight;
      const p = .1 + ((clamped + .5) / 6) * .9;
      scrollTo({ top: sectionTop + travel * p, behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    tabs.forEach((tab, i) => tab.addEventListener('click', () => go(i), options));
    root.querySelector('[data-ggf-prev]').addEventListener('click', () => go(active - 1), options);
    root.querySelector('[data-ggf-next]').addEventListener('click', () => go(active + 1), options);
    root.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    root.addEventListener('pointermove', event => {
      pointerX = event.clientX / innerWidth - .5; pointerY = event.clientY / innerHeight - .5; requestDraw();
      if (!down) return;
      const dx = event.clientX - down.x;
      if (Math.abs(dx) > 70) { const start = down.index; down = null; go(start + (dx < 0 ? 1 : -1)); }
    }, options);
    root.addEventListener('pointerdown', event => { if (event.button === 0) down = { x: event.clientX, index: Math.max(0, active) }; }, options);
    root.addEventListener('pointerup', () => { down = null; }, options);
    window.addEventListener('scroll', requestDraw, { passive: true, signal: controller.signal });
    window.addEventListener('resize', measure, options);
    reduced.addEventListener('change', measure, options);
    const timer = setInterval(requestDraw, 60);
    root.ggfCleanup = () => { controller.abort(); clearInterval(timer); cancelAnimationFrame(raf); };
    measure(); requestDraw();
  };
  document.querySelectorAll('.ggf').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ggf').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.ggf').forEach(root => root.ggfCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-ring-field"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ggfReady) return;
    root.dataset.ggfReady = 'true';
    const canvas = root.querySelector('.ggf__canvas');
    const ctx = canvas.getContext('2d', { alpha: true });
    const intro = root.querySelector('.ggf__intro');
    const chapters = [...root.querySelectorAll('[data-ggf-chapter]')];
    const tabs = [...root.querySelectorAll('[data-ggf-go]')];
    const currentLabel = root.querySelector('[data-ggf-current]');
    const closing = root.querySelector('.ggf__closing');
    const spectrum = root.querySelector('.ggf__spectrum');
    const curveGroup = root.querySelector('.ggf__curve-lines');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    root.querySelectorAll('.ggf__curve-link').forEach(line => {
      line.addEventListener('pointerenter', () => { curveGroup?.classList.add('is-hovering'); line.classList.add('is-hover'); }, options);
      line.addEventListener('pointerleave', () => { curveGroup?.classList.remove('is-hovering'); line.classList.remove('is-hover'); }, options);
      line.addEventListener('focus', () => { curveGroup?.classList.add('is-hovering'); line.classList.add('is-hover'); }, options);
      line.addEventListener('blur', () => { curveGroup?.classList.remove('is-hovering'); line.classList.remove('is-hover'); }, options);
      line.addEventListener('dblclick', event => { if (line.dataset.report) { event.preventDefault(); window.open(line.dataset.report, '_blank', 'noopener'); } }, options);
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let width = 0, height = 0, dpr = 1, count = 0, active = -2, raf = 0, time = 0, pointerX = 0, pointerY = 0, down = null;

    const fract = n => n - Math.floor(n);
    const rand = (i, seed) => fract(Math.sin(i * 12.9898 + seed * 78.233) * 43758.5453);
    const mix = (a, b, t) => a + (b - a) * t;
    const ease = t => t * t * (3 - 2 * t);

    function target(phase, i) {
      const r1 = rand(i, phase + 1), r2 = rand(i, phase + 7), r3 = rand(i, phase + 13);
      const cx = width * .72, cy = height * .52, span = Math.min(width, height);
      let x = cx, y = cy, color = 0, size = .7 + r3 * 1.4;
      if (phase === 0) {
        const jar = i < count * .78;
        if (jar) {
          const t = r1 * 4;
          const rw = Math.min(width * .22, 300), rh = Math.min(height * .3, 300);
          if (t < 1) { x = cx - rw + t * rw * 2; y = cy - rh; }
          else if (t < 2) { x = cx + rw; y = cy - rh + (t - 1) * rh * 2; }
          else if (t < 3) { x = cx + rw - (t - 2) * rw * 2; y = cy + rh; }
          else { x = cx - rw; y = cy + rh - (t - 3) * rh * 2; }
          x += (r2 - .5) * 7; y += (r3 - .5) * 7;
        } else {
          const wick = i % 3 - 1, t = r1;
          x = cx + wick * 52 + Math.sin(t * 8) * 5;
          y = cy - Math.min(height * .3, 300) - t * 95;
          color = 1;
        }
      } else if (phase === 1) {
        const t = i / count, lane = i % 5;
        const rise = fract(t * 5);
        const radius = 35 + lane * 32 + rise * 75;
        x = cx + Math.cos(rise * 8 + lane) * radius;
        y = height * .82 - rise * height * .67;
        color = lane % 2;
      } else if (phase === 2) {
        const lane = i % 9, t = Math.floor(i / 9) / Math.ceil(count / 9);
        x = cx - 150 + lane * 38 + Math.sin(t * 16 + lane) * 22;
        y = height * .84 - t * height * .7;
        color = lane % 3 === 0 ? 1 : 0;
      } else if (phase === 3) {
        const band = i % 3, t = Math.floor(i / 3) / Math.ceil(count / 3);
        x = width * .45 + t * width * .5;
        y = height * (.39 + band * .15) + Math.sin(t * 15 + band * 2) * 24 + (r2 - .5) * 15;
        color = band === 1 ? 1 : band === 2 ? 2 : 0;
        size += 1;
      } else if (phase === 4) {
        const angle = r1 * Math.PI * 2, radius = Math.sqrt(r2) * span * .31;
        x = cx + Math.cos(angle) * radius;
        y = cy + Math.sin(angle) * radius * .82;
        color = r3 > .72 ? 2 : 0;
        size = r3 > .92 ? 3.4 : .8 + r2 * 1.5;
      } else {
        const perimeter = i < count * .44;
        const rw = Math.min(width * .28, 390), rh = Math.min(height * .35, 340);
        if (perimeter) {
          const t = r1 * 4;
          if (t < 1) { x = cx - rw + t * rw * 2; y = cy - rh; }
          else if (t < 2) { x = cx + rw; y = cy - rh + (t - 1) * rh * 2; }
          else if (t < 3) { x = cx + rw - (t - 2) * rw * 2; y = cy + rh; }
          else { x = cx - rw; y = cy + rh - (t - 3) * rh * 2; }
        } else if (i < count * .70) {
          const angle = r1 * Math.PI * 2, radius = 22 + r2 * 58;
          x = cx - 205 + Math.cos(angle) * radius; y = cy - 125 + Math.sin(angle) * radius;
          color = 2; size = 1 + r3 * 1.5;
        } else {
          const t = r1 * Math.PI * 2, radius = 22 + r2 * 45;
          x = cx + 185 + Math.cos(t) * radius; y = cy - 120 + Math.sin(t) * radius * .55;
          color = 1; size = 1 + r3 * 1.8;
        }
        if (perimeter) {
          x += (r2 - .5) * 5; y += (r3 - .5) * 5; color = i % 8 === 0 ? 1 : 0;
        } else if (i < count * .70) {
          x += Math.cos(r3 * 12) * 5; y += Math.sin(r2 * 12) * 5;
        } else {
          x += (r2 - .5) * 5; y += (r3 - .5) * 5;
        }
      }
      return { x, y, color, size };
    }

    function measure() {
      dpr = Math.min(devicePixelRatio || 1, 2);
      width = canvas.clientWidth; height = canvas.clientHeight;
      canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      count = innerWidth < 640 ? 480 : 1180;
      draw();
    }

    function progress() {
      const rect = root.getBoundingClientRect();
      const travel = Math.max(1, root.offsetHeight - innerHeight);
      return Math.max(0, Math.min(1, -rect.top / travel));
    }

    function setActive(index) {
      if (active === index) return;
      active = index;
      intro.classList.toggle('is-past', index >= 0);
      chapters.forEach((chapter, i) => chapter.classList.toggle('is-active', i === index));
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
      currentLabel.textContent = index < 0 ? '00' : String(index + 1).padStart(2, '0');
      closing.classList.toggle('is-active', index === 5);
      spectrum.classList.toggle('is-active', index === 5);
    }

    function draw() {
      raf = 0;
      const p = reduced.matches || innerWidth < 640 ? 0 : progress();
      const story = Math.max(0, (p - .1) / .9);
      const raw = Math.min(5.999, story * 6);
      const phase = Math.floor(raw), local = ease(raw - phase), next = Math.min(5, phase + 1);
      setActive(p < .12 ? -1 : Math.min(5, Math.floor(Math.max(0, (p - .12) / .88) * 6)));
      ctx.clearRect(0, 0, width, height);
      const driftX = pointerX * 18, driftY = pointerY * 12;
      for (let i = 0; i < count; i++) {
        const a = target(phase, i), b = target(next, i);
        const x = mix(a.x, b.x, local) + driftX * (rand(i, 31) - .5);
        const y = mix(a.y, b.y, local) + driftY * (rand(i, 47) - .5) + Math.sin(time * .00035 + i) * 1.2;
        const c = local < .5 ? a.color : b.color;
        ctx.fillStyle = c === 1 ? 'rgba(80,122,54,.78)' : c === 2 ? 'rgba(120,152,90,.78)' : c === 3 ? 'rgba(139,157,102,.78)' : c === 4 ? 'rgba(167,184,137,.82)' : 'rgba(23,51,29,.42)';
        ctx.beginPath(); ctx.arc(x, y, mix(a.size, b.size, local), 0, Math.PI * 2); ctx.fill();
      }
      time = performance.now();
    }

    function requestDraw() { if (!raf) raf = requestAnimationFrame(draw); }
    function go(index) {
      const clamped = Math.max(0, Math.min(5, index));
      const sectionTop = root.getBoundingClientRect().top + scrollY;
      const travel = root.offsetHeight - innerHeight;
      const p = .1 + ((clamped + .5) / 6) * .9;
      scrollTo({ top: sectionTop + travel * p, behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    tabs.forEach((tab, i) => tab.addEventListener('click', () => go(i), options));
    root.querySelector('[data-ggf-prev]').addEventListener('click', () => go(active - 1), options);
    root.querySelector('[data-ggf-next]').addEventListener('click', () => go(active + 1), options);
    root.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    root.addEventListener('pointermove', event => {
      pointerX = event.clientX / innerWidth - .5; pointerY = event.clientY / innerHeight - .5; requestDraw();
      if (!down) return;
      const dx = event.clientX - down.x;
      if (Math.abs(dx) > 70) { const start = down.index; down = null; go(start + (dx < 0 ? 1 : -1)); }
    }, options);
    root.addEventListener('pointerdown', event => { if (event.button === 0) down = { x: event.clientX, index: Math.max(0, active) }; }, options);
    root.addEventListener('pointerup', () => { down = null; }, options);
    window.addEventListener('scroll', requestDraw, { passive: true, signal: controller.signal });
    window.addEventListener('resize', measure, options);
    reduced.addEventListener('change', measure, options);
    const timer = setInterval(requestDraw, 60);
    root.ggfCleanup = () => { controller.abort(); clearInterval(timer); cancelAnimationFrame(raf); };
    measure(); requestDraw();
  };
  document.querySelectorAll('.ggf').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ggf').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.ggf').forEach(root => root.ggfCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-ring-orbit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if(root.dataset.ggaReady) return;
    root.dataset.ggaReady = 'true';
    const controller = new AbortController(), options = {signal:controller.signal};
    const stage = root.querySelector('.gga__stage'), pin = root.querySelector('.gga__pin');
    const cards = [...root.querySelectorAll('.gga__card')], panels = [...root.querySelectorAll('.gga__read')], dots = [...root.querySelectorAll('[data-gga-go]')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const count = cards.length;
    let current = 0, position = 0, cardWidth = 340, scrollMode = false, scrollStart = 0, travel = 1400, raf = 0, pointer = null, suppressClick = false;
    const normalize = n => (n % count + count) % count;
    function playActive(){
      cards.forEach((card,i) => {
        const video = card.querySelector('video');
        if(!video) return;
        if(i === current && !reduced.matches && root.dataset.visible === 'true'){
          if(!video.getAttribute('src')) video.src = video.dataset.src;
          video.muted = true;
          video.play().then(() => {if(i === current && !video.paused) video.classList.add('is-playing');}).catch(() => video.classList.remove('is-playing'));
        } else {video.pause(); video.classList.remove('is-playing');}
      });
    }
    function paint(value){
      position = value;
      const selected = normalize(Math.round(value));
      cards.forEach((card,i) => {
        let d = normalize(i-value+count/2)-count/2;
        const distance = Math.abs(d);
        const angle = d * .36;
        const radius = cardWidth*2.8;
        const x = Math.sin(angle)*radius;
        const y = (1-Math.cos(angle))*radius + Math.min(distance,1)*9;
        card.style.transform = `translate3d(${x}px,${y}px,0) rotate(${d*14}deg) scale(${Math.max(.8,1-distance*.055)})`;
        card.style.filter = `grayscale(${Math.min(distance*.76,1)}) blur(${Math.min(distance*1.65,4)}px)`;
        card.style.opacity = String(Math.max(0,1-Math.pow(distance/2.5,1.3)*.92));
        card.style.zIndex = String(100-Math.round(distance*20));
        card.style.pointerEvents = distance>2 ? 'none' : 'auto';
        card.setAttribute('aria-selected',String(i===selected));
        card.tabIndex = i===selected ? 0 : -1;
        card.classList.toggle('is-active',i===selected);
        panels[i].hidden = i!==selected;
        panels[i].classList.toggle('is-active',i===selected);
        if(i===selected) dots[i].setAttribute('aria-current','step'); else dots[i].removeAttribute('aria-current');
      });
      if(selected!==current){current = selected; playActive();}
    }
    function readScroll(){
      raf = 0;
      if(!scrollMode || pointer) return;
      const progress = Math.max(0,Math.min(1,(scrollY-scrollStart)/travel));
      root.classList.add('is-scrubbing');
      paint(Math.round(progress*(count-1)*100)/100);
    }
    function measure(){
      root.classList.remove('is-scroll');
      root.classList.remove('is-scrubbing');
      cardWidth = cards[0].offsetWidth;
      const height = pin.offsetHeight;
      scrollMode = root.dataset.scroll === 'true' && innerWidth>900 && innerHeight>=760 && height<=innerHeight && !reduced.matches;
      if(scrollMode){
        root.style.setProperty('--gga-pin-h',height+'px');
        root.classList.add('is-scroll');
        scrollStart = root.getBoundingClientRect().top+scrollY;
        travel = root.offsetHeight-height;
      }
      paint(current);
      if(scrollMode) readScroll();
    }
    function go(index,focus=false){
      const next = normalize(index);
      root.classList.remove('is-scrubbing');
      if(scrollMode){
        window.scrollTo({top:scrollStart+travel*next/(count-1),behavior:reduced.matches?'instant':'smooth'});
      }else{
        let delta = next-normalize(position);
        if(delta>count/2) delta-=count;
        if(delta<-count/2) delta+=count;
        paint(position+delta);
      }
      if(focus) cards[next].focus({preventScroll:true});
    }
    cards.forEach((card,i) => {
      card.addEventListener('click',()=>{if(!suppressClick) go(i);},options);
      card.addEventListener('keydown',event=>{
        let target;
        if(event.key==='ArrowRight') target=current+1;
        if(event.key==='ArrowLeft') target=current-1;
        if(event.key==='Home') target=0;
        if(event.key==='End') target=count-1;
        if(target===undefined) return;
        event.preventDefault(); go(target,true);
      },options);
    });
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i),options));
    root.querySelector('[data-gga-next]').addEventListener('click',()=>go(current+1),options);
    root.querySelector('[data-gga-prev]').addEventListener('click',()=>go(current-1),options);
    stage.addEventListener('pointerdown',event=>{
      if(event.button!==0) return;
      pointer={id:event.pointerId,x:event.clientX,y:event.clientY,value:position,moved:false};
      suppressClick=false;
    },options);
    stage.addEventListener('pointermove',event=>{
      if(!pointer || event.pointerId!==pointer.id) return;
      const dx=event.clientX-pointer.x,dy=event.clientY-pointer.y;
      if(!pointer.moved && Math.abs(dx)<8) return;
      if(!pointer.moved && Math.abs(dy)>Math.abs(dx)){pointer=null;return;}
      pointer.moved=true; suppressClick=true;
      stage.setPointerCapture(event.pointerId);
      stage.classList.add('is-dragging');
      root.classList.remove('is-scrubbing');
      paint(pointer.value-dx/(cardWidth*.9));
    },options);
    function release(event){
      if(!pointer || event.pointerId!==pointer.id) return;
      const moved=pointer.moved;
      pointer=null; stage.classList.remove('is-dragging');
      if(stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      if(moved) go(Math.round(position));
    }
    stage.addEventListener('pointerup',release,options);
    stage.addEventListener('pointercancel',release,options);
    window.addEventListener('scroll',()=>{if(!raf) raf=requestAnimationFrame(readScroll);},{passive:true,signal:controller.signal});
    window.addEventListener('resize',measure,options);
    reduced.addEventListener('change',()=>{measure();playActive();},options);
    const visibility=new IntersectionObserver(entries=>{root.dataset.visible=String(entries[0].isIntersecting);playActive();},{threshold:.1});
    visibility.observe(root);
    root.classList.add('is-ready');
    measure();
    document.fonts.ready.then(()=>{if(root.isConnected) measure();});
    root.ggaCleanup=()=>{controller.abort();visibility.disconnect();cancelAnimationFrame(raf);cards.forEach(c=>c.querySelector('video')?.pause());};
  };
  document.querySelectorAll('.gga').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.gga').forEach(init));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.gga').forEach(root=>root.ggaCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-ring-salon"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.salonReady) return;
    root.dataset.salonReady = 'true';
    const viewport = root.querySelector('[data-salon-viewport]');
    const track = root.querySelector('.ggs-salon__track');
    const slides = [...root.querySelectorAll('.ggs-salon__slide')];
    const panels = [...root.querySelectorAll('.ggs-salon__readout')];
    const progress = root.querySelector('[data-salon-progress]');
    const currentLabel = root.querySelector('[data-salon-current]');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let current = 0, slideStep = 0, pointer = null, suppressClick = false;

    const measure = () => {
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      slideStep = slides[0].getBoundingClientRect().width + gap;
      paint(current, false);
    };
    const paint = (index, animate = true) => {
      current = Math.max(0, Math.min(slides.length - 1, index));
      if (!animate) track.style.transition = 'none';
      track.style.transform = `translate3d(${-current * slideStep}px,0,0)`;
      if (!animate) requestAnimationFrame(() => { track.style.transition = ''; });
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-selected', String(active));
        slide.tabIndex = active ? 0 : -1;
        panels[i].hidden = !active;
        panels[i].classList.toggle('is-active', active);
      });
      progress.style.transform = `scaleX(${current + 1})`;
      currentLabel.textContent = String(current + 1).padStart(2, '0');
    };
    const go = (index, focus = false) => {
      paint(index);
      if (focus) slides[current].focus({ preventScroll: true });
    };

    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => { if (!suppressClick) go(i); suppressClick = false; }, options);
      slide.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = current + 1;
        if (event.key === 'ArrowLeft') next = current - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = slides.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        go(next, true);
      }, options);
    });
    root.querySelector('[data-salon-prev]').addEventListener('click', () => go(current - 1), options);
    root.querySelector('[data-salon-next]').addEventListener('click', () => go(current + 1), options);
    viewport.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, start: current, moved: false };
      suppressClick = false;
    }, options);
    viewport.addEventListener('pointermove', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
      if (!pointer.moved && Math.abs(dx) < 8) return;
      if (!pointer.moved && Math.abs(dy) > Math.abs(dx)) { pointer = null; return; }
      pointer.moved = true;
      suppressClick = true;
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');
      track.style.transform = `translate3d(${-(pointer.start * slideStep) + dx}px,0,0)`;
    }, options);
    const release = event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX - pointer.x;
      const next = Math.abs(dx) > Math.min(90, slideStep * .18) ? pointer.start + (dx < 0 ? 1 : -1) : pointer.start;
      pointer = null;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      go(next);
    };
    viewport.addEventListener('pointerup', release, options);
    viewport.addEventListener('pointercancel', release, options);
    window.addEventListener('resize', measure, options);
    root.salonCleanup = () => controller.abort();
    measure();
    document.fonts.ready.then(() => { if (root.isConnected) measure(); });
  };
  document.querySelectorAll('.ggs-salon').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ggs-salon').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.ggs-salon').forEach(root => root.salonCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-workspace-atlas"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.constellationReady==='true')return;
    root.dataset.constellationReady='true';
    var host=root.closest('.shopify-section');
    var mapSection=host&&host.previousElementSibling;
    var map=mapSection&&mapSection.querySelector('.omd');
    var layers=map?[].slice.call(map.querySelectorAll('.omd__c, .omd__pin')):[];
    var buttons=[].slice.call(root.querySelectorAll('.gga__node'));
    var status=root.querySelector('.gga__status');
    var selected=null;
    function keys(button){return(button.dataset.pins||'').trim().split(/\s+/).filter(Boolean)}
    function paint(button){
      if(!map)return;
      var active=keys(button);
      map.classList.add('is-dim');
      layers.forEach(function(layer){layer.classList.toggle('is-on',active.indexOf(layer.dataset.k)>-1)});
    }
    function clear(){
      if(map)map.classList.remove('is-dim');
      layers.forEach(function(layer){layer.classList.remove('is-on')});
      buttons.forEach(function(button){button.setAttribute('aria-pressed','false')});
      selected=null;
      if(status)status.textContent='Choose a botanical to locate its source.';
    }
    function choose(button){
      selected=button;
      buttons.forEach(function(item){item.setAttribute('aria-pressed',item===button?'true':'false')});
      paint(button);
      if(status)status.textContent=button.dataset.name+' / '+button.dataset.origin;
    }
    buttons.forEach(function(button){
      button.addEventListener('mouseenter',function(){paint(button)});
      button.addEventListener('mouseleave',function(){if(selected)paint(selected);else clear()});
      button.addEventListener('focus',function(){paint(button)});
      button.addEventListener('click',function(){if(selected===button)clear();else choose(button)});
    });
    root.addEventListener('keydown',function(event){if(event.key==='Escape')clear()});
  }
  function boot(){[].slice.call(document.querySelectorAll('.gga')).forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-workspace-field-guide-origin"] && !Shopify.designMode) return;
  try {
    
(function(){
  var DELAY=130; /* hover intent, so sweeping the rail does not fire every panel */
  function init(root){
    if(root.dataset.guideReady==='true')return;
    root.dataset.guideReady='true';
    var tabs=[].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels=[].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    var cab=root.querySelector('.ggfd__cabinet');
    if(!tabs.length)return;
    var wantHover=root.dataset.hover==='1';
    var wantAuto=root.dataset.auto==='1';
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var active=0,hoverTimer=null,offscreen=false;

    function arm(){
      tabs.forEach(function(t){t.classList.remove('is-ticking')});
      if(!wantAuto||reduce)return;
      var t=tabs[active];
      void t.offsetWidth;            /* reflow, so the animation restarts */
      t.classList.add('is-ticking');
    }
    function show(i,focus){
      active=(i+tabs.length)%tabs.length;
      tabs.forEach(function(t,n){t.setAttribute('aria-selected',n===active?'true':'false');t.tabIndex=n===active?0:-1});
      panels.forEach(function(p,n){p.hidden=n!==active});
      if(focus)tabs[active].focus();
      arm();
    }
    function hold(on){ root.classList.toggle('ggfd--hold',!!on); }

    /* The advance rides on the bar finishing, so the two can never disagree. */
    root.addEventListener('animationend',function(e){
      if(e.animationName==='ggfd-tick') show(active+1,false);
    });

    tabs.forEach(function(tab,i){
      tab.addEventListener('click',function(){show(i,false)});   /* kept: touch has no hover */
      if(wantHover){
        tab.addEventListener('mouseenter',function(){
          clearTimeout(hoverTimer);
          hoverTimer=setTimeout(function(){show(i,false)},DELAY);
        });
        tab.addEventListener('mouseleave',function(){clearTimeout(hoverTimer)});
      }
      tab.addEventListener('keydown',function(e){
        if(e.key==='ArrowRight'){e.preventDefault();show(i+1,true)}
        if(e.key==='ArrowLeft'){e.preventDefault();show(i-1,true)}
      });
    });
    root.querySelectorAll('[data-guide-prev]').forEach(function(b){b.addEventListener('click',function(){show(active-1,false)})});
    root.querySelectorAll('[data-guide-next]').forEach(function(b){b.addEventListener('click',function(){show(active+1,false)})});

    /* WCAG 2.2.2 - anything self-updating needs a pause. At three seconds the
       pause matters more, not less. */
    if(cab){
      cab.addEventListener('mouseenter',function(){hold(true)});
      cab.addEventListener('mouseleave',function(){if(!offscreen)hold(false)});
      cab.addEventListener('focusin',function(){hold(true)});
      cab.addEventListener('focusout',function(){if(!cab.contains(document.activeElement)&&!offscreen)hold(false)});
    }
    /* Held while off-screen, or you scroll down to find it parked on a random
       specimen having burned a dozen cycles unseen. */
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(en){ offscreen=!en.isIntersecting; hold(offscreen); });
      },{threshold:.25}).observe(root);
    }
    arm();
  }
  function boot(){[].slice.call(document.querySelectorAll('.ggfd')).forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ggs-workspace-field-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.guideReady==='true')return;
    root.dataset.guideReady='true';
    var tabs=[].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels=[].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    var active=0;
    function show(index,focus){
      active=(index+tabs.length)%tabs.length;
      tabs.forEach(function(tab,i){tab.setAttribute('aria-selected',i===active?'true':'false');tab.tabIndex=i===active?0:-1});
      panels.forEach(function(panel,i){panel.hidden=i!==active});
      if(focus)tabs[active].focus();
    }
    tabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){show(index,false)});
      tab.addEventListener('keydown',function(event){
        if(event.key==='ArrowRight'){event.preventDefault();show(index+1,true)}
        if(event.key==='ArrowLeft'){event.preventDefault();show(index-1,true)}
      });
    });
    root.querySelectorAll('[data-guide-prev]').forEach(function(button){button.addEventListener('click',function(){show(active-1,false)})});
    root.querySelectorAll('[data-guide-next]').forEach(function(button){button.addEventListener('click',function(){show(active+1,false)})});
  }
  function boot(){[].slice.call(document.querySelectorAll('.ggfd')).forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
